import { Segment, toDateTimeStr, useGraphCtx } from '@mi-front/core';
import { theme } from '@mi-front/ui';
import { WaveformEl } from '../waveform/base/WaveformEl';
import { WaveformRenderer } from '../waveform/base/WaveformRenderer';
import NoAudio from '../waveform/base/message/NoAudio';
import { processSilentSegments } from '../waveform/silence-chunks-utils';
// const _ = require('lodash');

interface Props {
  readonly segments: readonly Segment[];
  readonly fgColor?: string;
  readonly bgColor?: string;
  readonly debug?: boolean;
}

export function SegmentsWaveform(p: Props) {
  const { segments, fgColor, bgColor, debug } = p;
  const { height, scale, compressed } = useGraphCtx();

  return (
    <g className="segments-waveform">
      {processSilentSegments(segments).map((segment, index: number) => {
        const x = Math.round(scale(segment.startTs)!);
        const width = Math.round(scale(segment.endTs)! - x);

        return (
          <WaveformEl
            debug={debug && `${toDateTimeStr(segment.startTs)} (${index})`}
            key={segment.id}
            startTs={segment.startTs}
            duration={segment.duration}
            x={x}
            width={width}
            height={height}
            bgColor={bgColor}
          >
            {segment.waveform ? (
              <WaveformRenderer
                waveform={segment.waveform}
                width={width}
                height={height}
                startTs={segment.startTs}
                x={x}
                fgColor={fgColor || theme.blue}
                compressed={compressed}
              />
            ) : (
              <NoAudio noText={compressed} parentWidth={width} parentHeight={height} />
            )}
          </WaveformEl>
        );
      })}
    </g>
  );
}
